<script lang="ts">
    import CardCarousel from "@shared/svelte/Components/Carousel/CardCarousel.svelte";
    import ShoppableUnitCard from "@shared/svelte/Components/ShoppableUnit/ShoppableUnitCard.svelte";
    import LayoutStore from "@shared/svelte/Stores/LayoutStore";
    import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
    import { getShoppableUnits } from "@shared/services/shoppable_unit_service";
    import { CarrotShoppableUnitAdEntity } from "@shared/services/event_tracking/entities";
    import type { ShoppableUnit } from "@shared/types/ShoppableUnit";
    import { isEmpty } from "lodash";
  
    export let shoppableUnit: ShoppableUnit;
    export let shouldFetchData: boolean = false;
    export let pageName: string | null = null;
    // discovery panel passes this in automatically but
    // trying to not do that anymore and just use the store
    export let mobileMode: boolean = false;
  
    // unused props from discovery panel
    mobileMode;
  
    const fetchData = async () => {
      shoppableUnit = await getShoppableUnits(pageName);
    };
  
    if (shouldFetchData) {
      fetchData();
    }
  
    const extractImageInfo = image => {
      return {
        src: image.image_url,
        alt: image.alt_text,
        assetType: image.asset_type,
      };
    };
  
    const trackingParams = () => {
      const shoppableUnitAdEntityParams: CarrotShoppableUnitAdEntity =
        new CarrotShoppableUnitAdEntity({
          interaction_id: shoppableUnit.interaction_id,
          object_tracking_id: shoppableUnit.object_tracking_id,
          forward_url: shoppableUnit.forward_url,
          carrot_ad_format: shoppableUnit.carrot_ad_format,
          creative_type: shoppableUnit.creative_type,
          asset_type: shoppableUnit.hero_image.asset_type,
          placement_name: shoppableUnit.placement_name,
          page_view_id: shoppableUnit.page_view_id,
        });
  
      return [shoppableUnitAdEntityParams];
    };
  
    $: windowWidth = 0;
  </script>
  
  <svelte:window bind:innerWidth={windowWidth} />
  
  {#if !isEmpty(shoppableUnit)}
    <TrackingContext entities={trackingParams()}>
      <section class="fizz-surface-blue" data-testid="shoppable-unit">
        <div class="fizz-inset-square-32 fizz-container">
          {#if $LayoutStore.isMobile && windowWidth < 700}
            <div class="fizz-stack-16">
              <ShoppableUnitCard
                sponsoredFlag
                tagLine={shoppableUnit.tag_line}
                forwardLink={shoppableUnit.forward_url}
                logoProps={extractImageInfo(shoppableUnit.brand_logo)}
                imageProps={extractImageInfo(shoppableUnit.hero_image)}
              />
            </div>
            <CardCarousel
              productLines={shoppableUnit.product_lines}
              carouselIdentifier={"shoppable_unit"}
              showTitle={false}
              carouselName={"shoppable_unit"}
            />
          {:else if windowWidth >= 700}
            <CardCarousel
              productLines={shoppableUnit.product_lines}
              carouselIdentifier={"shoppable_unit"}
              showTitle={false}
              shoppableUnit
              carouselName={"shoppable_unit"}
            >
              <ShoppableUnitCard
                slot="shoppable-unit"
                sponsoredFlag
                tagLine={shoppableUnit.tag_line}
                forwardLink={shoppableUnit.forward_url}
                logoProps={extractImageInfo(shoppableUnit.brand_logo)}
                imageProps={extractImageInfo(shoppableUnit.hero_image)}
              />
            </CardCarousel>
          {/if}
        </div>
      </section>
    </TrackingContext>
  {/if}
  